module.exports = global["$"] = require("-!/app/wp-content/themes/delaware-county/node_modules/expose-loader/index.js?jQuery!/app/wp-content/themes/delaware-county/node_modules/babel-loader/lib/index.js!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js-exposed
// module id = 0
// module chunks = 0 1 2 3 4 5 6